/* ショップ因子一覧リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { stores_list_read_index as read_index } from '../Const';
var StoreFactorList = function (_a) {
    var stores = _a.stores, handleRowChange = _a.handleRowChange;
    var rows = useState(10)[0];
    return (React.createElement(Grid, { data: stores, columns: [
            {
                id: 'myCheckbox',
                name: '',
                formatter: function (cell, row) {
                    return _(React.createElement("input", { className: "row-selection", type: "checkbox", value: "" + row.cells[read_index.fcshin].data, key: "" + row.cells[read_index.fcshin].data, onChange: function () { return handleRowChange(String(row.cells[read_index.id].data)); } }));
                },
                width: '10px',
            },
            {
                id: 'factor',
                name: '因子',
                width: '30px',
            },
            {
                id: 'start_date_adaptation',
                name: '適応開始日',
                width: '30px',
            },
            {
                id: 'end_date_adaptation',
                name: '適応終了日',
                width: '30px',
            },
            // 以下は画面に表示しないデータ（カラム）
            {
                id: 'id',
                hidden: true,
            },
        ], search: false, sort: false, pagination: {
            enabled: true,
            limit: rows,
        }, fixedHeader: true, height: "600px" }));
};
export default memo(StoreFactorList);
